import { useState } from "react";
import FullScreenLayout from "../fullScreenLayout";
import FullScreenDefault from "components/FullScreenDefault";
import OperatingMode from "components/OperatingMode";

const FullScreen = () => {
    const [isOperatingMode, setIsOperatingMode] = useState(true);

    const handleOperatingModeChange = (checked: boolean) => {
        setIsOperatingMode(checked);
    };

    return (
        <>
            <FullScreenLayout
                isOperatingMode={isOperatingMode}
                onOperatingModeChange={handleOperatingModeChange}
            >
                {isOperatingMode ? <OperatingMode /> : <FullScreenDefault />}
            </FullScreenLayout>
        </>
    );
};
export default FullScreen;
